import Vue from 'vue'
import App from './App.vue'
// import "./registerServiceWorker";
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import VueKonva from 'vue-konva'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import './vee-validate'
import Notifications from 'vue-notification'
import VueSimpleAlert from 'vue-simple-alert'
import globalMixins from '../src/mixins/globaMixins.js'
import VueQRCodeComponent from 'vue-qr-generator'
Vue.component('QrCode', VueQRCodeComponent)
Vue.config.productionTip = false
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VueKonva)
Vue.use(Notifications)
Vue.use(VueSimpleAlert, { reverseButtons: true })
Vue.mixin(globalMixins)
import numeral from 'numeral'
import moment from 'moment'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

import VueGtag from 'vue-gtag'

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-52751393-13' }
  },
  router
)

Vue.filter('numberFormat', function (value) {
  return numeral(value).format('0,0')
})

Vue.filter('decimalFormat', function (value) {
  return numeral(value).format('0,0')
})

Vue.filter('DateFormat', function (value, format) {
  if (moment(value).isValid()) {
    return moment(value).format(format)
  } else {
    return ''
  }
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
